<template>
    <div class="war-zone">
        <div class="promote-to-the-war-zone padding-botton" v-show="!isShowTop16">
            <div class="b flex-space-flex-start">
                <div v-for="(was, index) in warZone.top16 && warZone.top16" :key="index" class="big-group-div">
                    <div class=" arae-group" v-for="(item, index) in was" :key="index">
                        <img class="icon-jingji icon-jingji-left"
                            src="../../assets/images/winterGame/lab-jingji-left.png" v-if="item && item[0].promotion">
                        <img class="icon-jingji icon-jingji-right"
                            src="../../assets/images/winterGame/lab-jingji-right.png" v-if="item && item[1].promotion">
                        <div class="flex-space-between">
                            <div class="name">
                                <template v-if="item && item[0].team_name">
                                    <div class="flex-vertically-left-center the-world group-name">
                                        {{ item[0].team_name || '' }}
                                    </div>
                                    <div class="trophy">
                                        <img class="pic" src="../../assets/images/winterGame/jb.png" alt="">
                                        <span class="num">{{ item[0].score || 0 }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div>{{ item[0].name || '' }}</div>
                                    <div class="ranking">{{ item[0].rank }}</div>
                                </template>
                            </div>
                            <div class="vs">vs</div>
                            <div class="name text">
                                <template v-if="item && item[1].team_name">
                                    <div class="flex-vertically-left-center the-world group-name">
                                        {{ item[1].team_name || '' }}
                                    </div>
                                    <div class="trophy">
                                        <img class="pic" src="../../assets/images/winterGame/jb.png" alt="">
                                        <span class="num">{{ item[1].score || 0 }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div>{{ item[1].name || '' }}</div>
                                    <div class="ranking">{{ item[1].rank }}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-space-flex-start promote-to-the-war-zone qualifying-match">
            <div class="flex-space-between arae-group"
                v-for="(item, index) in warZone.topUpper8 && warZone.topUpper8.length > 0 ? warZone.topUpper8 : 2"
                :key="index"
                style="margin-bottom: 0"
                :style="isFinite(item) ? 'padding-top:0': ''"
                >
                <template v-if="warZone.topUpper8 && warZone.topUpper8.length > 0">
                    <img class="icon-jingji  icon-jingjis icon-jingji-bevel-angle"
                        src="../../assets/images/winterGame/lab-jingji.png" v-if="item && item[0].promotion">
                    <img class="icon-jingji  icon-jingjis icon-jingji-bevel-right"
                        src="../../assets/images/winterGame/lab-jingji-right2.png" v-if="item && item[1].promotion">
                    <div class="flex-vertically-center name">
                        <div class="flex-vertically-left-center the-world">{{ item[0].team_name || 0 }}</div>
                        <div class="trophy">
                            <img class="pic" src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">{{ item[0].score || 0 }}</span>
                        </div>
                    </div>
                    <div class="vs">vs</div>
                    <div class="flex-vertically-center name text">
                        <div class="flex-vertically-left-center the-world group-name">{{ item[1].team_name || 0 }}</div>
                        <div class="trophy">
                            <img class="pic" src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">{{ item[1].score || 0 }}</span>
                        </div>
                    </div>
                </template>
                <div class="flex-vertically-center undetermined" v-else><span>待定</span></div>
            </div>
        </div>
        <div class="flex-space-between">
            <div class="top-line"><img class="pic" src="../../assets/images/winterGame/top-line.png" /></div>
            <div class="top-line"><img class="pic" src="../../assets/images/winterGame/top-line.png" /></div>
        </div>
        <div class="flex-space-flex-start take-the-crown ">
            <div class="flex-vertically-center-no arae-group" style="margin:0"
                v-for="(item, index) in warZone && warZone.topUpper4 && warZone.topUpper4.length > 0 ? warZone.topUpper4 : 2"
                :key="index">
                <img class="icon-jingji  icon-jingjis icon-jingji-bevel-angle"
                    src="../../assets/images/winterGame/lab-jingji.png" v-if="item && item.promotion">
                <div class="champion-li">
                    <template v-if="warZone && warZone.topUpper4 && warZone.topUpper4.length > 0">
                        <div class="text-line2">{{ item.team_name || '' }}</div>
                        <div></div>
                        <div>
                            <img src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">{{ item.score || 0 }}</span>
                        </div>
                    </template>
                    <div class="undetermined" v-else>待定</div>
                </div>
            </div>
        </div>
        <div class="flex-space-between">
            <div class="botton-line"><img class="pic" src="../../assets/images/winterGame/botton-line.png" /></div>
        </div>
        <div class="middle-area">
            <div class=" champion">
                <div class="flex-vertically-center champion-li">
                    <img class="icon-jingji  icon-jingjis icon-jingji-bevel-angle"
                        src="../../assets/images/winterGame/lab-jingji.png"
                        v-if="warZone && warZone.topUpper2 && warZone.topUpper2.length > 0 && warZone.topUpper2[0].promotion">
                    <div v-if="warZone.topUpper2 && warZone.topUpper2.length > 0">
                        <div class="text-line2">
                            {{ warZone && warZone.topUpper2 && warZone.topUpper2.length > 0 && warZone.topUpper2[0].team_name || '' }}
                        </div>
                        <div>
                            <img src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">
                                {{ warZone && warZone.topUpper2 && warZone.topUpper2.length > 0 && warZone.topUpper2[0].score || 0 }}
                            </span>
                        </div>
                    </div>
                    <div class="undetermined" v-else>待定</div>
                </div>
                <div class="vertical-bar"></div>
            </div>
            <div class="qlzq">
                <div class="boss">
                    <img src="../../assets/images/winterGame/qlzq.png" alt="">
                    <div class="flex-space-between  name"><span>{{ groupName || ''}}</span><span>冠军</span></div>
                </div>
                <div class="vertical-bar"></div>
            </div>
            <div class="champion">
                <div class="flex-vertically-center champion-li">
                    <img class="icon-jingji  icon-jingjis icon-jingji-bevel-angle"
                        src="../../assets/images/winterGame/lab-jingji.png"
                        v-if="warZone && warZone.topUpper2 && warZone.topUpper2.length > 0 && warZone.topUpper2[1].promotion">
                    <div v-if="warZone.topUpper2 && warZone.topUpper2.length > 0">
                        <div class="text-line2">
                            {{ warZone && warZone.topUpper2 && warZone.topUpper2.length > 0 &&
    warZone.topUpper2[1].team_name || ''
                            }}
                        </div>
                        <div>
                            <img src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">
                                {{ warZone && warZone.topUpper2 && warZone.topUpper2.length > 0 &&
    warZone.topUpper2[1].score || 0
                                }}
                            </span>
                        </div>
                    </div>
                    <div class="undetermined" v-else>待定</div>
                </div>
            </div>
        </div>
        <div class="flex-space-between">
            <div class="botton-line rotate"><img class="pic" src="../../assets/images/winterGame/botton-line.png" />
            </div>
        </div>
        <div class="flex-space-flex-start take-the-crown ">
            <div class="flex-vertically-center-no arae-group" style="margin:0"
                v-for="(item, index) in warZone.topLower4 && warZone.topLower4.length > 0 ? warZone.topLower4 : 2"
                :key="index">
                <img class="icon-jingji  icon-jingjis icon-jingji-bevel-angle"
                    src="../../assets/images/winterGame/lab-jingji.png" v-if="item && item.promotion">
                <div class="champion-li">
                    <template v-if="warZone.topLower4 && warZone.topLower4.length > 0">
                        <div class="text-line2">{{ item.team_name || '' }}</div>
                        <div></div>
                        <div>
                            <img src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">{{ item.score || 0 }}</span>
                        </div>
                    </template>
                    <div class="undetermined" v-else>待定</div>
                </div>
            </div>
        </div>
        <div class="flex-space-between">
            <div class="top-line rotate"><img class="pic" src="../../assets/images/winterGame/top-line.png" /></div>
            <div class="top-line rotate"><img class="pic" src="../../assets/images/winterGame/top-line.png" /></div>
        </div>
        <div class="flex-space-flex-start promote-to-the-war-zone qualifying-match">
            <div class="flex-space-between arae-group" style="padding-top: 14px"
                v-for="(item, index) in warZone.topLower8 && warZone.topLower8.length > 0 ? warZone.topLower8 : 2"
                :key="index"
                :style="isFinite(item) ? 'padding-top:0': 'padding-top: 12px'"
                >
                <template v-if="warZone.topLower8 && warZone.topLower8.length > 0">
                    <img class="icon-jingji  icon-jingjis icon-jingji-bevel-angle"
                        src="../../assets/images/winterGame/lab-jingji.png" v-if="item && item[0].promotion">
                    <img class="icon-jingji  icon-jingjis icon-jingji-bevel-right"
                        src="../../assets/images/winterGame/lab-jingji-right2.png" v-if="item && item[1].promotion">
                    <div class="name">
                        <div class="flex-vertically-left-center the-world">{{ item[0].team_name || '' }}</div>
                        <div class="trophy">
                            <img class="pic" src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">{{ item[0].score || 0 }}</span>
                        </div>
                    </div>
                    <div class="vs">vs</div>
                    <div class="name text">
                        <div class="flex-vertically-left-center the-world">{{ item[1].team_name || '' }}</div>
                        <div class="trophy">
                            <img class="pic" src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">{{ item[1].score || 0 }}</span>
                        </div>
                    </div>
                </template>
                <div class="flex-vertically-center undetermined" v-else><span>待定</span></div>
            </div>
        </div>
        <div class="promote-to-the-war-zone" style="padding-top: 50px" v-show="isShowTop16">
            <div class="b flex-space-flex-start">
                <div v-for="(was, index) in warZone.top16 && warZone.top16" :key="index" class="big-group-div">
                    <div class=" arae-group" v-for="(item, index) in was" :key="index">
                        <img class="icon-jingji icon-jingji-left"
                            src="../../assets/images/winterGame/lab-jingji-left.png" v-if="item && item[0].promotion">
                        <img class="icon-jingji icon-jingji-right"
                            src="../../assets/images/winterGame/lab-jingji-right.png" v-if="item && item[1].promotion">
                        <div class="flex-space-between">
                            <div class="name">
                                <template v-if="item && item[0].team_name">
                                    <!-- <img class="icon-jingji icon-jingji-left"
                                src="../../assets/images/winterGame/lab-jingji-left.png"
                                v-if="item && item[0].promotion"> -->
                                    <div class="flex-vertically-left-center the-world group-name">
                                        {{ item[0].team_name || '' }}</div>
                                    <div class="trophy">
                                        <img class="pic" src="../../assets/images/winterGame/jb.png" alt="">
                                        <span class="num">{{ item[0].score || 0 }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div>{{ item[0].name || '' }}</div>
                                    <div class="ranking">{{ item[0].rank }}</div>
                                </template>
                            </div>
                            <div class="vs">vs</div>
                            <div class="name text">
                                <template v-if="item && item[1].team_name">
                                    <div class="flex-vertically-left-center the-world group-name">
                                        {{ item[1].team_name || '' }}</div>
                                    <div class="trophy">
                                        <img class="pic" src="../../assets/images/winterGame/jb.png" alt="">
                                        <span class="num">{{ item[1].score || 0 }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div>{{ item[1].name || '' }}</div>
                                    <div class="ranking">{{ item[1].rank }}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="box" ref="box">
          <div class="run left"> </div>
          <div class="run right"> </div>
          fsfsdfsdf大幅上升到发送到发送到发送到发送到发送到发的是发送
        </div> -->
    </div>
</template>
<script>
import { number } from 'yargs';

export default {
    props: {
        warZone: {
            type: Object,
            default: () => {
                top16: [];
                topUpper8: [];
                topLower8: [];
                topUpper4: [];
                topLower4: [];
                topUpper2: [];

            }
        },
        isShowTop16: {
            type: Boolean,
            default: () => true
        },
        groupName: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            afterSecondRound: false,
        }
    },
    watch: {
    },
    mounted() {
        this.$nextTick(() => {
            this.$set(this.warZone, 'top16', this.warZone.top16 || [])
            this.$set(this.warZone, 'topUpper8', this.warZone.topUpper8 || [])
            this.$set(this.warZone, 'topLower8', this.warZone.topLower8 || [])
            this.$set(this.warZone, 'topUpper4', this.warZone.topUpper4 || [])
            this.$set(this.warZone, 'topLower4', this.warZone.topLower4 || [])
            this.$set(this.warZone, 'topUpper2', this.warZone.topUpper2 || [])
        })
        console.log('组件接受', this.warZone)

        // const afterSecondRound = ref(false)
        // const setSecondRound = () => {
        //     let secondRoundTime = new Date('2023-01-29 00:00:00').getTime()
        //     let currentTime = new Date().getTime()
        //     afterSecondRound.value = currentTime >= secondRoundTime
        // }
        // let topHeight = this.$refs.box.offsetHeight
        // console.log(topHeight)
    }
}
</script>
<style lang="less" scoped>
@import '../../assets/style/global.less';

* {
    box-sizing: border-box
}

.a {
    display: flex;

    &.after-second-round {
        flex-direction: column-reverse;

        .zone-out-grid {
            margin-top: 0.85rem;
        }
    }

    &.before-second-round {
        flex-direction: column;

        .zone-out-layer {
            margin-top: 0.85rem;
        }
    }
}

.undetermined {
    text-align: center;
    margin: 0 auto;
}

.undetermined {
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.box {
    width: 200px;
    min-height: 120px;
    background: pink;
    position: relative;

    .run {
        border-style: solid;
        border-color: transparent;
        border-width: 60px 0 60px 10px;
        border-left-color: pink;
        position: absolute;
        top: 0;
    }

    .left {
        left: -10px;
        transform: rotate(180deg);
    }

    .right {
        right: -10px;
    }
}

.war-zone {
    padding-top: 48px;
    padding-bottom: 48px;

    .arae-group,
    .champion-li {
        position: relative;

        .icon-jingji {
            display: block;
            position: relative;
            position: absolute;
            top: 0;
            width: 64px;

            &.icon-jingjis {
                width: 74px;
                height: 28px;
            }
        }

        .icon-jingji-left {
            left: 0;
        }

        .icon-jingji-right {
            right: 0;
        }

        .icon-jingji-bevel-angle {
            left: 13px;
        }

        .icon-jingji-bevel-right {
            right: 13px;
        }
    }

    .promote-to-the-war-zone {
        margin: 0 -7px;

        &.after-second-round {
            flex-direction: column-reverse;

        }

        &.before-second-round {
            flex-direction: column;
        }

        &.padding-botton {
            padding-bottom: 64px;
        }

        .big-group-div {
            width: 50%;

            &:nth-child(2) {
                .arae-group {
                    background: linear-gradient(180deg, #E3E1FF 0%, #FBE1FF 100%);
                }
            }

            &:nth-child(3) {
                .arae-group {
                    background: linear-gradient(180deg, #C8E9FF 0%, #C8E5FF 100%);
                }
            }

            &:nth-child(4) {
                .arae-group {
                    background: linear-gradient(180deg, #C4F0EE 0%, #C4E9F0 100%);
                }
            }
        }

        // column-count: 2;//想要排成的列数
        //     column-gap: 0;
        .arae-group {
            // width: calc(50% - 14px);
            height: 124px;
            margin: 0 7px 12px 7px;
            padding: 20px 12px 0 12px;
            background: linear-gradient(180deg, #E8F0D5 0%, #D7F0D9 100%);
            border-radius: 8px;
            text-align: center;

            >div {
                height: 100%;
            }

            // .group-name{
            //     min-height: 66px;
            // }
            .name {
                width: 50%;
                font-size: 20px;
                font-weight: 400;
                color: #333333;

                .ranking {
                    font-size: 22px;
                    font-weight: 400;
                    color: #96741E;
                    padding-top: 10px;
                }

                .the-world {
                    padding: 0 6px;
                }

                .trophy {

                    .pic {
                        width: 22px;
                        height: 22px;
                    }

                    .num {
                        font-size: 22px;
                        font-weight: 400;
                        color: #96741E;
                        word-break: break-all;
                        padding-left: 6px;
                    }
                }
            }

            .vs {
                width: 48px;
                font-size: 32px;
                font-weight: bold;
                color: #96741E;
                display: flex;
                align-items: center;
            }
        }
    }

    .top-line {
        width: calc(50% - 14px);

        &.rotate {
            transform: rotate(180deg);
        }

        .pic {
            display: block;
            width: 164px;
            margin: 0 auto;
        }
    }

    .botton-line {
        width: 100%;

        .pic {
            display: block;
            width: 340px;
            margin: 0 auto;
        }

        &.rotate {
            transform: rotate(180deg);
        }
    }

    .qualifying-match {

        .arae-group {
            width: calc(50% - 14px);
            position: relative;

            &:nth-child(1) {
                background: url(../../assets/images/winterGame/promotion1.png) no-repeat;
                background-size: 100% 100%;

            }

            &:nth-child(2) {
                background: url(../../assets/images/winterGame/promotion2.png) no-repeat;
                background-size: 100% 100%;

            }
        }
    }

    .take-the-crown {
        // min-height: 110px;

        .arae-group {
            width: calc(50% - 14px);
            position: relative;
            background: url(../../assets/images/winterGame/blue-bac.png) no-repeat;
            background-size: 100% 100%;
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: #333333;
            // padding-top: 22px;
            // padding-bottom: 10px;
            height: 120px;

            .champion-li {
                padding: 10px 50px;

                .num {
                    font-size: 22px;
                    font-weight: 400;
                    color: #96741E;
                    padding-left: 6px;
                }
            }

        }
    }

    .middle-area {
        .champion {
            width: 260px;
            margin: 0 auto;
            font-size: 20px;
            font-weight: 600;
            color: #333333;

            .champion-li {
                text-align: center;
                background: url(../../assets/images/winterGame/guog.png) no-repeat;
                background-size: 100% 100%;
                padding: 10px;
                height: 114px;

                .num {
                    font-size: 22px;
                    font-weight: 400;
                    color: #96741E;
                    padding-left: 10px;
                }
            }
        }

        .qlzq {
            width: 370px;
            margin: 0 auto;

            .boss {
                width: 100%;
                height: 98px;
                position: relative;
                z-index: 1;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: -1;
                    display: block;
                    width: 100%;
                    height: 100%;
                }

                .name {
                    height: 100%;
                    font-size: 40px;
                    font-weight: 600;
                    color: #002569;
                    padding: 0 38px;
                }
            }

        }

        .vertical-bar {
            width: 2px;
            height: 50px;
            background: #7CABFF;
            margin: 0 auto;
        }
    }
}
</style>